import { createAction, props } from '@ngrx/store';

import { RestUnitRenewalTargetModel } from '@shared/interfaces/renevals.interface';
import { RestThresholdSection } from '@shared/interfaces/rest-threshold-section';

/**
 * Threshold sections
 */
export const loadAllThresholds = createAction('[Management] Load all thresholds');
export const loadAllThresholdsSuccess = createAction(
  '[Management] All thresholds loading success',
  props<{ thresholdSections: RestThresholdSection[] }>()
);
export const loadAllThresholdsFailed = createAction('[Management] All thresholds loading failed');

/**
 * Thresholds Property
 */
export const loadThresholdsProperty = createAction(
  '[Management] Load thresholds property',
  props<{ portfolioId: number }>()
);
export const loadThresholdsPropertySuccess = createAction(
  '[Management] thresholds property loading success',
  props<{ thresholdProperty: RestThresholdSection[] }>()
);
export const loadThresholdsPropertyFailed = createAction('[Management] thresholds property loading failed');

/**
 * Thresholds task
 */
export const loadThresholdsTask = createAction('[Management] Load thresholds task');
export const loadThresholdsTaskSuccess = createAction(
  '[Management] thresholds task loading success',
  props<{ thresholdTask: RestThresholdSection[] }>()
);
export const loadThresholdsTaskFailed = createAction('[Management] thresholds task loading failed');
export const setThresholdsConfig = createAction(
  '[Management] set thresholds config',
  props<{ threshold: RestThresholdSection }>()
);
export const setThresholdsConfigSuccess = createAction('[Management] set thresholds config success');
export const setThresholdsConfigFailed = createAction('[Management] set thresholds config failed');

/**
 * get renewal target list
 */
export const getRenewalTargetList = createAction(
  '[Management] get renewal target list',
  props<{ propertyId: number }>()
);
export const getRenewalTargetListSuccess = createAction(
  '[Management] get renewal target list success',
  props<{ renewalTargetList: RestUnitRenewalTargetModel[] }>()
);
export const getRenewalTargetListFailure = createAction('[Management] get renewal target list failure');

/**
 * update renewal target
 */
export const updateRenewalTarget = createAction(
  '[Management] update renewal target ',
  props<{ renewalTargetModels: RestUnitRenewalTargetModel[] }>()
);
export const updateRenewalTargetSuccess = createAction('[Management] update renewal target success');
export const updateRenewalTargetFailure = createAction('[Management] update renewal target failure');
